import { ActionType, Action, AgentPricingTab, ViewPageLoadedData, ItemType, EditPageLoadedData, ChangeSchoolOverrideSpec } from "app/pages/AgentPricing/actionTypes";
import { AgentCommissionDto, AgentCommissionRateQueryResult, AgentCommissionRateQueryDto, AgentCommissionVersionDto } from "app/shared/model/AgentCommissionDto";
import { CurrentAgentCommissionDialog } from "app/pages/AgentPricing/modules/EditDialogs";
import { Country, School } from "app/shared/model";


export function viewPageLoaded(agentCommission: AgentCommissionDto, data: ViewPageLoadedData) : Action { 
    return {
        type: ActionType.ViewPageLoaded, 
        agentCommission: agentCommission,
        data: data      
    };
}

export function editPageLoaded(agentCommission: AgentCommissionDto, data: EditPageLoadedData) : Action { 
    return {
        type: ActionType.EditPageLoaded, 
        agentCommission: agentCommission,
        data: data      
    };
}

export function changeTab(tab: AgentPricingTab) : Action {
    return {
        type: ActionType.ChangeTab, 
        tab: tab       
    };
}

export function rateFinderQueryRunning() {
    return {
        type: ActionType.RateFinderQueryRunning
    } as const;
}

export function rateFinderQueryResult(request: AgentCommissionRateQueryDto, result: AgentCommissionRateQueryResult) {
    return {
        type: ActionType.RateFinderQueryResult, 
        request: request,
        result: result
    } as const;
}

export function changeRateFinderCriteria(itemType?: ItemType, itemId?: string, schoolId?: string) : Action {
    return {
        type: ActionType.ChangeRateFinderCriteria,
        itemType: itemType,
        itemId: itemId, 
        schoolId: schoolId
    };
}

export function changeRate(columnId: string, ruleId: string, rate: string) : Action {
    return {
        type: ActionType.ChangeRate,
        columnId: columnId,
        ruleId: ruleId,
        rate: rate
    }
}

export function changeStartDate(newStartDate: string) : Action {
    return {
        type: ActionType.ChangeStartDate,
        newDate: newStartDate
    }
}

export function changeEndDate(newEndDate: string | null) : Action {
    return {
        type: ActionType.ChangeEndDate,
        newDate: newEndDate
    }
}

export function changeCurrentDialog(dialog: CurrentAgentCommissionDialog) : Action {
    return {
        type: ActionType.ChangeCurrentDialog,
        dialog: dialog
    }
}

export function changeSchoolOverrides(overrides: ChangeSchoolOverrideSpec[]) : Action {
    return {
        type: ActionType.ChangeSchoolOverrides,
        schoolOverrides: overrides
    }
}

export function startSavingRates(changeNumber: number) : Action {
    return {type: ActionType.StartSavingRates, changeNumber};
}

export function ratesSaveSuccessful(changeNumber: number) : Action {
    return {type: ActionType.SaveRatesSuccessful, changeNumber};
}

export function ratesSaveError(changeNumber: number) : Action {
    return {type: ActionType.ErrorSavingRates, changeNumber};
}

export function ratesValidationError(message: string) : Action {
    return {type: ActionType.RatesValidationError, message};
}

export function startFetchPublishedVersions() : Action {
    return { type: ActionType.StartFetchPublishedVersions }
}

export function fetchPublishedVersionsSuccessful(versions: AgentCommissionVersionDto[], countries: Country[], schools: School[]) : Action {
    return { 
        type: ActionType.FetchPublishedVersionsSuccess, 
        versions: versions, 
        countries: countries,
        schools: schools
    }
}

export function fetchPublishedVersionsError() : Action {
    return { type: ActionType.ErrorFetchingPublishedVersions }
}

export function changeSelectedPublishedVersion(versionCode: string) : Action {
    return { 
        type: ActionType.ChangeSelectedPublishedVersion,
        versionCode: versionCode
     }
}